/**
 * @generated SignedSource<<e06ac8c09177867f4dc075687053c080>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GuildsScreenNewHeader_query$data = {
  readonly viewer: {
    readonly id: string;
  } | null | undefined;
  readonly " $fragmentType": "GuildsScreenNewHeader_query";
};
export type GuildsScreenNewHeader_query$key = {
  readonly " $data"?: GuildsScreenNewHeader_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"GuildsScreenNewHeader_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GuildsScreenNewHeader_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "d1083bc934b44377954779a041bf1d85";

export default node;
